export default __webpack_public_path__ + "static/media/CompanySetup.6e6bfa03.svg";